import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';

@Component({
    selector: 'ellf-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterComponent {
  constructor(
    @Inject('version') private version: string,
    @Inject('env') private env: string
  ) {}

  public getVersion() {
    return `${this.version} ${this.env}`;
  }
}
